import { render } from "./elevation_text_resolver.vue?vue&type=template&id=59a37a06"
import script from "./elevation_text_resolver.vue?vue&type=script&lang=js"
export * from "./elevation_text_resolver.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__